import { FormEvent, useState } from 'react'
import { Link as RouterLink, Navigate } from 'react-router'
import { Alert, Box, Button, Link, Paper, Stack, TextField, Typography } from '@mui/material'
import { useAuth, ApiError } from '../auth/AuthContext.js'
import { HappyOpsLogo } from '../components/HappyOpsLogo.js'

export const LoginPage = () => {
  const { user, login } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | undefined>(undefined)
  const [submitting, setSubmitting] = useState(false)

  if (user) return <Navigate to="/" replace />

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setSubmitting(true)
    setError(undefined)
    try {
      await login(email, password)
    } catch (err) {
      setError(
        err instanceof ApiError && err.status === 401
          ? 'E-Mail oder Passwort ist falsch.'
          : 'Anmeldung fehlgeschlagen. Bitte später erneut versuchen.',
      )
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="background.default"
    >
      <Paper sx={{ p: 4, width: 360 }} elevation={3}>
        <Box display="flex" alignItems="center" gap={1.5} mb={3}>
          <HappyOpsLogo width={36} height={36} />
          <Typography variant="h5">Anmelden</Typography>
        </Box>
        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            {error && <Alert severity="error">{error}</Alert>}
            <TextField
              label="E-Mail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              required
            />
            <TextField
              label="Passwort"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Button type="submit" variant="contained" disabled={submitting}>
              Anmelden
            </Button>
            <Link component={RouterLink} to="/forgot-password" variant="body2">
              Passwort vergessen?
            </Link>
          </Stack>
        </form>
      </Paper>
    </Box>
  )
}
